import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PrimaryButton } from '@/components';
import { ApiTransactionAPIModelStatusEnum as TransactionAPIModelStatusEnum } from '@/generated/api/fps/core';
import { BlankLayout } from '@/layout';
import { logout } from '@/model/global/actions';
import { makeSelectIsFrameView } from '@/model/global/selectors';
import { UIState } from '@/model/global/types';
import { actions } from '@/model/withdrawal';
import { makeSelectStep } from '@/model/withdrawal/selectors';
import { WithdrawalStep, WithdrawalUIState } from '@/model/withdrawal/types';
import { useResultFields } from '@/pages/withdrawal/hooks';
import { FailedView, ProgressView, SuccessView } from '@/pages/withdrawal/pages/StatusPage/components';

const selectStatus = makeSelectStep();
const selectIsFrame = makeSelectIsFrameView();

const dataTest = 'status';

export const StatusPage: React.FC = () => {
  const history = useHistory();
  const { status, step } = useSelector(selectStatus);
  const transaction = useResultFields();
  const dispatch = useDispatch();
  const isFrame = useSelector(selectIsFrame);

  if (!transaction) {
    // should never happened
    return <BlankLayout />;
  }
  if (step === WithdrawalStep.Running) {
    return <ProgressView transaction={transaction} data-test={dataTest} />;
  }
  if (status === TransactionAPIModelStatusEnum.Finished) {
    return (
      <SuccessView
        data-test={dataTest}
        basePath={UIState.WITHDRAWAL}
        transaction={transaction}
        action={{
          title: (
            <FormattedMessage
              id={
                isFrame
                  ? 'withdrawal.pages.result.success.submit.title.iframe'
                  : 'withdrawal.pages.result.success.submit.title.main'
              }
            />
          ),
          run: (): void => {
            logout()(dispatch);
          },
        }}
      />
    );
  }
  return (
    <FailedView
      data-test={dataTest}
      status={status}
      transaction={transaction}
      action={
        status === TransactionAPIModelStatusEnum.Cancelled ? (
          <PrimaryButton
            data-test={dataTest && `${dataTest}-back`}
            title={<FormattedMessage id="withdrawal.pages.result.failed.submit.title.cancelled" />}
            onClick={async () => {
              await actions.storeStep({})(dispatch);
              history.push(`${WithdrawalUIState.PREPARE}`);
            }}
          />
        ) : (
          <PrimaryButton
            data-test={dataTest && `${dataTest}-back`}
            title={
              <FormattedMessage
                id={
                  isFrame
                    ? 'withdrawal.pages.result.success.submit.title.iframe'
                    : 'withdrawal.pages.result.success.submit.title.main'
                }
              />
            }
            onClick={async () => {
              await actions.storeStep({})(dispatch);
              history.push(`${WithdrawalUIState.PREPARE}`);
            }}
          />
        )
      }
    />
  );
};

export default StatusPage;
